export var PUBLISH = 0;
export var SUBSCRIBE = 1;
export var RESET = 2;
export var VALUE = 4;
